import type { OnboardingBrowserRuntime } from '../common/services/onboarding-browser-runtime';

/** 查新用户首次引导依赖的浏览器运行时能力。 */
export interface NoveltySearchOnboardingRuntime extends OnboardingBrowserRuntime {
    /** 获取当前登录账号 ID；账号不存在时返回空字符串。 */
    getIdentityId(): Promise<string>;
    /** 判断当前用户是否已登录。 */
    isUserLogin(): Promise<boolean>;
}

/** 查新用户首次引导运行时的容器标识。 */
export const NoveltySearchOnboardingRuntime = Symbol('NoveltySearchOnboardingRuntime');
